import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_3 = {
  key: 0,
  class: "md:t-28m text-wrh-blue-600 flex items-center justify-start mdlg:t-32m whitespace-nowrap"
}

import {
  PropType, toRefs, watch, ref,
} from 'vue';
import { useRoute } from 'vue-router';
import { MenuIcon, XIcon } from '@heroicons/vue/outline';
import { isMobile } from '@/util/funcs';
import CurrentUserMenu from './CurrentUserMenu.vue';
import SidebarIcon from './icons/SidebarIcon.vue';
import Logo from './icons/Logo.vue';
import { NavigationLinks } from '@/types';
import { Routes } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  props: {
  sidebarOpen: {
    type: Boolean,
    required: true,
  },
  navigation: {
    type: Array as PropType<NavigationLinks>,
    required: false,
  },
},
  emits: ['openSidebar', 'closeSidebar'],
  setup(__props, { emit }) {

const props = __props

const { sidebarOpen, navigation } = toRefs(props);

const isMyAccountPage = ref(false);

const route = useRoute();

watch(route, () => {
  if (route.name === Routes.MY_ACCOUNT) {
    isMyAccountPage.value = true;
  } else {
    isMyAccountPage.value = false;
  }
}, {
  flush: 'pre', immediate: true, deep: true,
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isMobile)())
      ? (_openBlock(), _createElementBlock("header", {
          key: 0,
          class: _normalizeClass(['flex items-center min-h-14 justify-between sm:pl-3 bg-white w-full pr-1 z-3 shadow-modal', {'bg-opacity-70 fixed': !isMyAccountPage.value}])
        }, [
          (!_unref(sidebarOpen))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "h-12 w-12 inline-flex items-center justify-center rounded-md text-wrh-blue-400 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-wrh-blue-400",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openSidebar')))
              }, [
                _hoisted_1,
                _createVNode(_unref(MenuIcon), {
                  class: "h-6 w-6",
                  "aria-hidden": "true"
                })
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('closeSidebar')))
              }, [
                _hoisted_2,
                _createVNode(_unref(XIcon), {
                  class: "h-6 w-6 text-wrh-blue-400",
                  "aria-hidden": "true"
                })
              ])),
          _createVNode(Logo, { class: "w-24 h-auto" }),
          _createVNode(CurrentUserMenu, { class: "moblands:flex md:hidden" })
        ], 2))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigation), (item) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: item.name,
        custom: "",
        to: { name: item.routeName }
      }, {
        default: _withCtx(({ isActive }) => [
          (isActive && _unref(isMobile)())
            ? (_openBlock(), _createElementBlock("h1", {
                key: 0,
                class: _normalizeClass(['t-22m text-wrh-blue-600 flex items-center justify-center mb-4 whitespace-nowrap', !isMyAccountPage.value ? 'mt-18' : 'mt-5'])
              }, [
                (item.routeName)
                  ? (_openBlock(), _createBlock(SidebarIcon, {
                      key: 0,
                      name: item.routeName,
                      class: "text-wrh-blue-600 mr-4 flex-shrink-0 h-6 w-6 md:h-8 md:w-8"
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(item.name), 1)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128)),
    (!_unref(isMobile)())
      ? (_openBlock(), _createElementBlock("header", {
          key: 1,
          class: _normalizeClass(['py-4 mx-auto px-2 md:px-4 xl:px-10 flex items-center justify-between w-full bg-white top-0 z-3 shadow-modal', {'bg-opacity-70 sticky': !isMyAccountPage.value}])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigation), (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.name,
              custom: "",
              to: { name: item.routeName }
            }, {
              default: _withCtx(({ isActive }) => [
                isActive
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
                      (item.routeName)
                        ? (_openBlock(), _createBlock(SidebarIcon, {
                            key: 0,
                            name: item.routeName,
                            class: "text-wrh-blue-600 mr-4 flex-shrink-0 h-8 w-8"
                          }, null, 8, ["name"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128)),
          _createVNode(CurrentUserMenu, { class: "hidden md:block" })
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})